import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ledge-table',
  templateUrl: './ledge-table.component.html',
  styleUrls: ['./ledge-table.component.css']
})
export class LedgeTableComponent implements OnInit {

  @Input() transactionHistories;

  constructor() { }

  ngOnInit() {
  }

}
